import { CosmosClient } from "@azure/cosmos";
import { authProvider } from '../utils/authProvider';

export class CourseUtil {
    
    public async GetList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();
        
        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/CourseColGetList?code=Fm9DW50q61FMsPYaS4h0aSew8MbZ5hyQCB8fRy2VAPB2aEjSm95bPg==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error:' + errorResponse.Message };
        }
    }

    public async Read(_id: string, _year: number) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/CourseColRead?code=aaRZQcQVQrR/MwbaXpT/7QJoSvIfGd/mZg5CJES92ZcoLGogsSTujQ==';
        let API_PARAM = '&id=' + _id + '&period=' + _year;
        let API = API_URL + API_ENDPOINT + API_PARAM;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async Create(_doc: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/CourseColCreate?code=TjPH9nTQQcFCaZMcH1LZc4d2d3SHAafonLG3UAYLgqjUZadl22DE/w==';

        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Newly created document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Update(_keyValues: any) {
        let accountInfo = await authProvider.getAccountInfo();
        //console.log(_keyValues);
        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/CourseColSet?code=huKJhuA6g/5TJTnvqc0TjMe7hMJPIrX9cTegMyQoc6V1lk55Eybpig==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_keyValues)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors, isConflict : result.isConflict };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Delete(_id: string, _year: number) {
        let accountInfo = await authProvider.getAccountInfo();
        
        let _doc : any = {};
        _doc.id = _id;
        _doc.period = _year;

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/CourseColDelete?code=0x9/IfIi21WQmim2ZTp4BjGzrICHtHzwcIKp02aaNo0PPZ1a43g51A==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }


}